
import { Component, Mixins, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";
import * as modals from "@/lib/modals";
import { ScheduleDeliveryOrderModel } from "@/models/ui/scheduleDelivery";
import { PreviewScheduleOrderResource } from "@/models/api/orders/schedule";
import { GetOrdersRequest } from "@/models/api/orders/get";
import VisibleOptions from "@/components/widgets/VisibleOptions.vue";


@Component({
  name: modals.unscheduleDeliveryModal,
  components: {
    VisibleOptions
}})
export default class UnscheduleDeliveryModal extends Mixins(mixin) {
  pendingRequests: null;
  orderModule: OrderModule = getModule(OrderModule);
  orders: ScheduleDeliveryOrderModel[] = null;
  unscheduleOrders: number[] = null;
  loading: boolean = true;
  noteText: string = null;
  facilityViewable: boolean;
  customerViewable: boolean;

  get deliveryForId() {
    if(!this.selectedItem)
      return 0;
      
    return this.selectedItem.deliveryForId ?? 0;
  }

  @Watch("pendingRequests")
  pendingRequestsChanged(val) {
    if (val === 0) this.hideModal();
  }

  get ordersWithMissingShipsWithOrders() {
    if (this.orders)
      return this.orders.filter(
        x => x.missingShipsWithOrderNumbers && x.missingShipsWithOrderNumbers.length > 0
      );
    else return [];
  }

  get isOrderScheduled(){
    return this.selectedItem &&  this.selectedItem.scheduledDeliveryDate == "2049-12-31T00:00:00";
  }

  async load() {
    this.show();
    this.orders = [];
    this.noteText = null;
    this.facilityViewable = true;
    this.customerViewable = true;

    const request = {
      orderNumbers: (this.selectedItems || []).map(x => x.number)
    };

    let result: PreviewScheduleOrderResource[] = null;

    this.unscheduleOrders = [];
    try {
      result = await this.orderModule.previewScheduleOrder(request);
    } catch (ex) {}
    this.loading = false;

    if (this.selectedItem) {
      for (let index = 0; index < this.selectedItems.length; index++) {
        const currentOrder = this.selectedItems[index];
        const previewOrder = result
          ? result.find(x => x.orderHeaderNumber == currentOrder.number)
          : null;

        let reasonCodes: any[] = null;

        this.orders.push({
          headerNumber: currentOrder.number,
          crn: currentOrder.crn,
          timeframeStart: null,
          timeframeEnd: null,
          driverNote: previewOrder.driverNote,
          reasonCode: null,
          reasonText1: null,
          reasonText2: null,
          availableReasonCodes: reasonCodes,
          remarks: previewOrder.remarks,
          missingShipsWithOrderNumbers: previewOrder.missingShipsWithHeaderNumbers,
          truckInfo: previewOrder.truckInfo,
          scheduledDeliveryDate: null,
          deliveryForId: currentOrder.deliveryForId,          
          reasonCodeLegend: []
        });
      }
    }
  }

  async addOrder(headerNumber) {
    if (this.unscheduleOrders.find(x => x === +headerNumber)) {
      this.unscheduleOrders = this.unscheduleOrders.filter(x => x !== +headerNumber);
    } else {
      this.unscheduleOrders.push(+headerNumber);
    }
  }

  async addAllShipsWithOrders() {
    this.isLoading = true;
    for (let index = 0; index < this.selectedItems.length; index++) {
      let order = this.selectedItems[index];

      let allOrders = this.orders.find(x => x.headerNumber === order.number)
        .missingShipsWithOrderNumbers;

      allOrders.push(+order.number);

      try {
        await this.orderModule.unscheduleOrder({ orderHeaderNumbers: allOrders });
        this.addActionResult({
          number: order.number,
          success: true,
          message: `Orders ${allOrders.join(", ")} successfully unscheduled.`
        });
      } catch (error) {
        this.addActionResult({
          number: order.number,
          success: false,
          message: error.response.data.message,
          errors:
            error.response.data && error.response.data.errors ? error.response.data.errors : null,
          errorMessages:
            error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
        });
      }
    }
    await this.refreshOrders();
    this.hideModal();
  }

  async save() {
    this.isLoading = true;
    for (let index = 0; index < this.selectedItems.length; index++) {
      let order = this.selectedItems[index];

      try {
        this.unscheduleOrders.push(+order.number);
        var payload = { orderHeaderNumbers: [ +order.number ] };
        if (this.noteText) {
          payload["orderNote"] = {
            text: this.noteText,
            facilityViewable: this.facilityViewable,
            customerViewable: this.customerViewable
          }
        }

        await this.orderModule.unscheduleOrder(payload);
        this.addActionResult({
          number: order.number,
          success: true,
          message: `Order ${order.number} successfully unscheduled.`
        });
      } catch (error) {
        this.addActionResult({
          number: order.number,
          success: false,
          message: error.response.data.message,
          errors:
            error.response.data && error.response.data.errors ? error.response.data.errors : null,
          errorMessages:
            error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
        });
      }
    }
    await this.refreshOrders();
    this.hideModal();
  }

  changeNoteVisibleTo(value) {
    this.customerViewable = value.customerViewable;
    this.facilityViewable = value.facilityViewable;
  }
}
